<template>
    <div
        class="g-search"
    >
        <button
            v-if="!searching && /result/.test($route.path)"
            @click="$router.back()"
            class="back-result"
        ></button>
        <div
            class="search-content"
            :class="[searching ? 'searching' : 'not-searching']"
            @mousedown="handleSearchContainerMousedown"
        >
            <button
                v-if="searching"
                @click="$router.back()"
                class="back"
            ></button>
            <GInput
                :value.sync="searchValue"
                :autofocus="searching"
                @enter="() => handleSearch()"
            />
            <button
                @click="() => handleSearch()"
                class="search-btn"
            ></button>
        </div>
    </div>
</template>

<script>
// components
import GInput from './GInput'

// mixins
import HistoryMixin from '@/mixins/history'

// eventBus
import eventBus from '@/eventBus'

// store
import { mapGetters } from 'vuex'
import { sendEvent } from '@/methods/ga'

export default {
    name: 'Search',
    mixins: [HistoryMixin],
    components: {
        GInput
    },
    props: {
        searching: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            searchValue: ''
        }
    },
    computed: {
        ...mapGetters([
            'hotWord'
        ])
    },
    watch: {
        searchValue (val) {
            this.$emit('input', val)
        }
    },
    methods: {
        handleSearchContainerMousedown (event) {
            if (!this.searching) {
                event.preventDefault()

                const isResult = this.$route.name === 'Result'

                const isClickButton = event.target.className === 'search-btn'

                if (isClickButton) {
                    if (isResult) {
                        this.$router.push({
                            path: '/searching',
                            query: {
                                w: this.searchValue,
                                t: new Date().getTime()
                            }
                        })
                    } else if (this.hotWord) {
                        sendEvent('home:search:default_word')
                        this.$router.push({
                            path: '/result',
                            query: {
                                w: this.hotWord,
                                t: new Date().getTime()
                            }
                        })
                    } else {
                        this.$router.push({
                            path: '/searching',
                            query: {
                                w: this.searchValue,
                                t: new Date().getTime()
                            }
                        })
                    }
                } else {
                    this.$router.push({
                        path: '/searching',
                        query: {
                            w: this.searchValue,
                            t: new Date().getTime()
                        }
                    })
                }
            }
        },
        handleSearch () {
            if (!this.searchValue && !this.hotWord) return

            if (!this.searching) return

            const jumpW = this.searchValue || this.hotWord
            this.saveHistory(jumpW)

            this.$router.replace({
                path: '/result',
                query: {
                    w: jumpW,
                    t: new Date().getTime()
                }
            })
        },
    },
    mounted () {
        const {
            query: {
                w
            } = {}
        } = this.$route
        this.searchValue = w

        eventBus.$once('searchHistory', (hi) => {
            this.searchValue = hi
            this.handleSearch()
        })
    }
}
</script>

<style lang="less" scoped>
.g-search {
    display: flex;
    flex-direction: row;
    align-items: center;
    .back-result {
        width: 10px;
        height: 20px;
        background: url(../assets/back-result.png) no-repeat center;
        background-size: 10px 20px;
        margin-right: 15px;
    }
    .search-content {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        &.not-searching {
            border: 1px solid #D7D7D7;
            border-radius: 3px;
            height: 40px;
            .search-btn {
                width: 61px;
                height: 42px;
                border-radius: 0 3px 3px 0;
                background: #4AB9E2 url(../assets/search.png) no-repeat center;
                background-size: 22px 22px;
                margin-right: -1px;
            }
        }
        &.searching {
            .search-btn {
                width: 22px;
                height: 22px;
                margin-left: 10px;
                background: url(../assets/search-blue.png) no-repeat center;
                background-size: 22px 22px;
            }
        }
        .back {
            width: 20px;
            height: 20px;
            background: url(../assets/back.png) no-repeat center;
            background-size: 20px 20px;
            margin-right: 10px;
        }
        .g-input {
            flex: 1;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue